import mapboxgl from 'mapbox-gl';

export const addAttribution = (map: mapboxgl.Map): void => {
	const control = new mapboxgl.AttributionControl({ compact: true });
	if (!map.hasControl(control)) {
		map.addControl(control, 'bottom-left');
	}
};
